import * as React from 'react'
import { MatchClasses } from '../hooks'
import { LightTooltip } from '@sales-center/components'
import InfoOutlined from '@mui/icons-material/InfoOutlined'

import Typography from '@mui/material/Typography'

type Props = {
  styles: MatchClasses
}

export const InfoTooltip: React.FC<Props> = ({ styles }) => (
  <LightTooltip
    title={
      <ul style={styles.toolTipList}>
        <Typography component="li">
          Start by searching/selecting a Bill-to, and we&apos;ll pull in the
          related service locations so they can be matched.
        </Typography>
        <Typography component="li">
          If there is no match you can choose to create a new service location
          which will be added under the selected Bill-to.
        </Typography>
        <Typography component="li">
          Matching this record will overwrite the information in Sales Center
          with the location&apos;s information. This cannot be undone.
        </Typography>
      </ul>
    }
  >
    <span>
      <InfoOutlined
        style={styles.infoIcon}
        data-test-id="matchLocationInfoIcon"
      />
    </span>
  </LightTooltip>
)
